import { err, ok, Result } from "../result";
import { ProblemDetails } from "../models/Http";
import { StoreEvent } from "../models/Store";
import { get } from "./api";
import moment from "moment";
import { MobilePOSPurchase } from "../models/MobilePOS";

export const getUserEvents = async (
  from: Date,
  to: Date,
  storeIds: string[] = []
): Promise<Result<ProblemDetails, ReadonlyArray<StoreEvent>>> => {
  let additionalQuery = "";

  storeIds.forEach(val => {
    additionalQuery = `${additionalQuery}&storeIds=${val}`;
  });

  const response = await get(
    `/v1/dashboard/events?periodFrom=${moment(from).format(
      "YYYY-MM-DD HH:mm:ss"
    )}
    &periodTo=${moment(to).format("YYYY-MM-DD HH:mm:ss")}${additionalQuery}`
  );
  const content = await response.json();

  if (response.ok) {
    return ok(content as ReadonlyArray<StoreEvent>);
  }

  return err(content as ProblemDetails);
};

export const getMobilePOSPurchases = async (
  from: Date,
  to: Date
): Promise<Result<ProblemDetails, ReadonlyArray<MobilePOSPurchase>>> => {
  const response = await get(
    `/v1/dashboard/mobile-pos?periodFrom=${moment(from).format(
      "YYYY-MM-DD HH:mm:ss"
    )}
    &periodTo=${moment(to).format("YYYY-MM-DD HH:mm:ss")}`
  );
  const content = await response.json();

  if (response.ok) {
    return ok(content as ReadonlyArray<MobilePOSPurchase>);
  }

  return err(content as ProblemDetails);
};
